import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [{ key: 'name', trans: 'name', defaultOperator: 'like' }],
        type: 'input',
        value: [],
    },
    {
        key: [
            {
                key: 'errorTypeId',
                trans: 'ErrorTypes',
                keyService: 'ErrorTypes',
                defaultOperator: '=',
            },
        ],
        type: 'orm',
        value: [],
    },
    {
        key: [
            {
                key: 'createdDate',
                trans: 'createdDate',
                defaultOperator: '=',
            },
        ],
        type: 'date',
        value: [],
    },
];
